'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TraceTypeLineIcon = function TraceTypeLineIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 46 46' }, props),
        _react2.default.createElement(
            'g',
            { fill: 'none' },
            _react2.default.createElement('path', { d: 'M0 0h46v46H0z' }),
            _react2.default.createElement('path', { stroke: '#25fdfc', d: 'M5.087 39l9.391-12.913 8.218 7.043L37.957 12', strokeMiterlimit: '10', strokeWidth: '2.348' }),
            _react2.default.createElement('path', { stroke: '#1d9bfb', d: 'M12.13 37.826l11.74-15.261 8.217 7.044 8.217-11.739', strokeMiterlimit: '10', strokeWidth: '2.348' })
        )
    );
};

exports.default = TraceTypeLineIcon;